/**
 * 校验规则上下文：默认规则 + @app 应用层覆写
 * 校验规则是追加合并（数组 concat），不是替换
 *
 * 1:1 还原参考项目 @pkg/diffconfig/src/diffValidators.js
 */
import { FIELD_RULES as appRules } from '@app/config/validators'
import { FIELD_RULES as standardRules } from './config/validators'

// 合并：标准规则 + 应用规则（追加到数组末尾）
const allKeys = new Set([...Object.keys(standardRules), ...Object.keys(appRules)])

export const FIELD_RULES: Record<string, any[]> = {}

allKeys.forEach((key) => {
  FIELD_RULES[key] = [...(standardRules[key] || []), ...(appRules[key] || [])]
})
